export default class DtoQualitometerState {
    constructor(obj) {
        this.qualitometer = obj.qualitometer
        this.stateId = obj.stateId
        this.startDate = obj.startDate
        this.value = obj.value
        this.comment = obj.comment
        this.stateName = obj.stateName
        this.mnemonic = obj.mnemonic
        this.finality = obj.finality
        this.principal = obj.principal
        this.stateComment = obj.stateComment
        this.computedStateCode = obj.computedStateCode
        this.order = obj.order
        this.isClass = obj.isClass
    }
}